import { has } from "lodash";

import {
  isAddInWebView,
  setAddInIsCloudMode,
  setAddInViewSession,
} from "./utilities";

const API_VERSION = "1.1";
const API_SRC_URL = `https://appsforoffice.microsoft.com/lib/${API_VERSION}/hosted/office.js`;

const SUPPORT_ERROR =
  "This add-in requires feature set 1.1 for WordApi or WordApiOnline for desktop and online Word";

const getIsSetSupported = (key, value) => {
  return window.Office.context.requirements.isSetSupported(key, value);
};

const bootstrapOfficeAddIn = async () => {
  const isAddIn = isAddInWebView();

  if (!isAddIn) {
    return [false];
  }

  setAddInIsCloudMode();
  setAddInViewSession();

  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = API_SRC_URL;
    script.type = "text/javascript";
    script.async = true;

    script.onload = async () => {
      const hasNamespace = has(window, "Office");
      if (!hasNamespace) {
        return resolve([false]);
      }

      try {
        const { host, platform } = (await window.Office.onReady()) || {};
        const isWord = host === window.Office.HostType.Word;
        if (!isWord) {
          return resolve([false, `${host} not currently supported`]);
        }

        const isWordApiSupported = getIsSetSupported("WordApi", API_VERSION);
        const isOnlineApiSupported = getIsSetSupported(
          "WordApiOnline",
          API_VERSION
        );

        if (!isWordApiSupported && !isOnlineApiSupported) {
          return resolve([false, SUPPORT_ERROR]);
        }

        console.warn(`🗒️ Office is now ready in ${host} on ${platform}`);
        return resolve([true]);
      } catch (err) {
        console.error(err);
        return resolve([false]);
      }
    };
    document.body.appendChild(script);
  });
};

export default bootstrapOfficeAddIn;
